// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__266LN","options":"AnswerScale_options__3Nh1x","selected":"AnswerScale_selected__19UzG"};